function initBookingSlider() {
  var swiper = new Swiper(".MBSSwiper", {
    slidesPerView: 1,
    loop: true,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    speed: 1000,    
    spaceBetween: 15,
    navigation: {
      nextEl: ".m-mc-next",
      prevEl: ".m-mc-prev",
      hideOnClick: false,
      disabledClass: "swiper-button-disabled",
      lockClass: "swiper-button-lock"
    },
  });
}